import { Button, TextInput } from '@neo4j-ndl/react';
import { useForm, useWatch } from 'react-hook-form';

import { ConnectionUrlInput } from '../connection-modal/connection-url-input';
import { DataSourceCard } from './data-source-card';

interface FormInputs {
  name: string;
  url: string;
}

interface ExternalDataSourceEditorProps {
  name: string;
  url: string;
  onCancel: () => void;
  onRemove: () => void;
  onSave: (inputs: FormInputs) => void;
}

export function ExternalDataSourceEditor(props: ExternalDataSourceEditorProps) {
  const { control, handleSubmit, register, setValue } = useForm<FormInputs>({
    defaultValues: {
      name: props.name,
      url: props.url,
    },
  });

  const urlField = register('url', { required: true });
  const url = useWatch({ control, name: urlField.name });
  const nameField = register('name');

  const onSubmit = handleSubmit(props.onSave);

  return (
    <DataSourceCard
      actions={
        <Button color="danger" fill="outlined" size="small" onClick={() => props.onRemove()}>
          Remove
        </Button>
      }
      name={props.name}
    >
      <div className="flex gap-4">
        <div className="flex-1 ">
          <ConnectionUrlInput {...urlField} onValueChange={(value) => setValue(urlField.name, value)} value={url} />
        </div>
        <div className="flex-1">
          <TextInput
            {...nameField}
            isFluid
            size="medium"
            placeholder={url}
            label="Connection alias"
            htmlAttributes={{
              name: nameField.name,
            }}
          />
        </div>
      </div>
      <div className="flex justify-end gap-2">
        <Button color="neutral" fill="outlined" size="small" onClick={() => props.onCancel()}>
          Cancel
        </Button>
        <Button
          fill="outlined"
          size="small"
          onClick={() => {
            void onSubmit();
          }}
        >
          Save
        </Button>
      </div>
    </DataSourceCard>
  );
}
